<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addCourseDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="courseDate" label="日期">
          <el-date-picker
            v-model="form.courseDate"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item required prop="classType" label="班级类型:">
          <el-select
            @change="changeClassTypeVal"
            v-model="form.classType"
            placeholder="选择班级类型"
          >
            <el-option
              v-for="item in this.courseTypeList.courseTypeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item required label="课程时间段:">
          <!-- <el-time-select
            placeholder="起始时间"
            @change="changeBeginTime"
            v-model="form.beginTime"
            :picker-options="{
              start: '08:00',
              step: '00:15',
              end: '21:30',
            }"
          ></el-time-select>
          <el-time-select
            placeholder="结束时间"
            v-model="form.endTime"
            :picker-options="{
              start: '08:00',
              step: '00:15',
              end: '21:30',
              minTime: form.beginTime,
            }"
          ></el-time-select> -->
          <el-time-picker      
            placeholder="起始时间"
            v-model="form.beginTime"
            :picker-options="{
              selectableRange: '08:00:00 - 21:30:00',
              format: 'HH:mm'
            }"
            value-format="HH:mm"
            @change="changeBeginTime"
          />
          <el-time-picker
            placeholder="结束时间"  
            v-model="form.endTime"
            :picker-options="{
              selectableRange: endRange,
              format: 'HH:mm'
            }"
            value-format="HH:mm"
          />
        </el-form-item>

        <!-- <el-form-item prop="courseHours" label="课时:">
          <el-input type="text" v-model="form.courseHours"></el-input>
        </el-form-item> -->

        <el-form-item required prop="courseLocation" label="课程地点:">
          <el-select
            @change="changeVal"
            v-model="form.courseLocation"
            placeholder="选择课程地点"
          >
            <el-option
              v-for="item in this.courseLocationList.courseLocationList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item required prop="coursePackages" label="选择课包:">
          <!-- <el-checkbox-group v-model="form.coursePackages" size="small">
             <el-checkbox v-for="coursePackage in this.coursePackageList.coursePackageList" :label="coursePackage.text" :key="coursePackage.value">{{coursePackage.text}}</el-checkbox>
          </el-checkbox-group> -->
          <el-cascader
            v-model="form.coursePackages"
            :options="options"
            :props="props"
            collapse-tags
            :show-all-levels="false"
            style="width:50%"
            clearable
          ></el-cascader>
        </el-form-item>

        <el-form-item required prop="studentMax" label="学员上限:">
          <el-input type="text" v-model="form.studentMax"></el-input>
        </el-form-item>

        <el-form-item required prop="studentMin" label="学员下限:">
          <el-input type="text" v-model="form.studentMin"></el-input>
        </el-form-item>

        <el-form-item required prop="courseReleaseDate" label="发布时间:">
          <el-date-picker
            v-model="form.courseReleaseDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item prop="cancelHour" label="取消小时数">
          <el-input
            type="text"
            placeholder="请输入取消小时数"
            v-model="form.cancelHour"
          ></el-input>
        </el-form-item>

        <el-form-item prop="cancelHour" label="自动取消小时数">
          <el-input
            type="text"
            placeholder="请输入自动取消小时数"
            v-model="form.autoCancelHour"
          ></el-input>
        </el-form-item>

<!--        <el-form-item prop="sort" label="排序">-->
<!--          <el-input-->
<!--            type="text"-->
<!--            placeholder="请输入排序（数字）"-->
<!--            v-model="form.sort"-->
<!--          ></el-input>-->
<!--        </el-form-item>-->

        <el-form-item prop="courseContent" label="学习内容">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入学习内容"
            v-model="form.courseNote"
          ></el-input>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addUnBeginCourse, editCourse } from "@/api/course";
import { getFormatCoursePackagesForCourse } from "@/api/coursepackage";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";
import { getCoursepackagesByLocationIdAndClasstypeId } from "@/api/locationAndClasstypeAndCoursepackage";
import { getclasstypeandtimebyclasstypeid } from "@/api/classtypeandtime";
import { getByLocationId } from "@/api/locationAndCounts";

export default {
  name: "addFundDialogs",
  data() {
    let validateData = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "telephoneNumber") {
          text = "手机号";
        } else if (rule.field == "name") {
          text = "姓名";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        let numReg = /^1[3456789]\d{9}$/;
        if (!numReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }
    };
    return {
      //test
      props: { multiple: true, emitPath: false },
      options: [],
      isVisible: this.isShow,
      endRange: '08:00:00 - 21:30:00',
      time: -1,
      form: {
        id: "",
        courseDate: "",
        beginTime: "",
        endTime: "",
        classType: "",
        coursePackages: [],
        courseLocation: "",
        studentMax: "",
        studentMin: "",
        courseReleaseDate: "",
        cancelHour: "",
        sort: "",
        courseContent: "",
      },
      form_rules: {
        telephoneNumber: [
          { required: true, validator: validateData, trigger: "blur" },
        ],
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        memberType: [
          { required: true, message: "请选择会员类型", trigger: "blur" },
        ],
        memberStatus: [
          { required: true, message: "请选择会员状态", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    courseTypeList: Object,
    courseLocationList: Object,
    coursePackageList: Object,
    formatList: Object,
  },
  computed: {
    ...mapGetters(["addCourseDialog"]),
  },
  created() {},
  mounted() {
    // console.log(this.formatList);
    this.getFormatCoursePackagesForCourse();
    if (this.addCourseDialog.type === "edit") {
      this.form = this.dialogRow.param;
      this.form.coursePackages = this.form.coursePackages.split(",");
      console.log(this.form.coursePackages);
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    changeBeginTime() {
      if (this.time == -1) {
        this.changeClassTypeVal();
      }
      if (this.time != -1 && this.form.beginTime != "") {
        // 开始时间的时，分
        var hours = parseInt(this.form.beginTime.split(":")[0]);
        var mins = parseInt(this.form.beginTime.split(":")[1]);
        // console.log(hours);
        // console.log(mins);
        // 分钟相加，除以60，的商
        var qMins = parseInt((mins + parseInt(this.time)) / 60);
        // 分钟相加，除以60，的余数
        var rMins = (mins + parseInt(this.time)) % 60;
        // console.log(qMins + "," + rMins);
        // 小时相加，除以24，的商
        var qHours = parseInt((hours + parseInt(qMins)) / 24);
        var rHours = (hours + parseInt(qMins)) % 24;
        // console.log(rHours);
        var afterHours = rHours;
        var afterMins = rMins;
        if (rHours < 10) {
          afterHours = "0" + rHours;
        }
        if (rMins < 10) {
          afterMins = "0" + rMins;
        }
        this.endRange = this.form.beginTime+":00 - 21:30:00"
        this.form.endTime = afterHours + ":" + afterMins;
        // console.log(this.form.endTime);
      }
      this.autoCalcEndTime()
    },
    autoCalcEndTime() {
      //自动计算结束时间
      if (this.addCourseDialog.type === "add"){
        if(this.form.beginTime) {
          let hour = this.form.beginTime.split(':')[0]
          let minute = this.form.beginTime.split(':')[1]
          // let classHour = this.courseTypeList.courseTypeList.find(item => item.value === this.form.classType).classHour
          // let finalHour = parseInt(hour) + parseInt(classHour)
          let m = this.courseTypeList.courseTypeList.find(item => item.value === this.form.classType).classMinute
          let finalHour = parseInt(hour) + parseInt(( parseInt(minute) + parseInt(m) )/60 )
          console.log(parseInt(( parseInt(minute) + parseInt(m) )/60 ))
          minute = ( parseInt(minute) + parseInt(m) ) % 60
          if(finalHour > 23) {
            finalHour = 23
          }
          if(finalHour < 10) {
            finalHour = '0' + finalHour
          }else {
            finalHour = String(finalHour)
          }
          if(minute == 0){
            minute = '0' + minute
          }
          this.form.endTime = finalHour + ':' + minute
        }
      }     
    },
    changeClassTypeVal() {
      if (this.form.classTypeId != "") {
        // console.log(this.form.classType);
        getclasstypeandtimebyclasstypeid({
          classtypeId: this.form.classType,
        }).then((res) => {
          console.log(res);
          // if (res.data.data.classtypeandtime != null) {
          //   this.time = res.data.data.classtypeandtime.time;
          //   this.changeBeginTime();
          // } else {
          //   this.time = -1;
          //   this.form.endTime = "";
          // }
          var arr = []
          res.data.data.courseTypeData.forEach(item => {
            arr.push(item.value)
          })
          this.form.coursePackages = arr
        });
      }
      this.autoCalcEndTime()
    },
    changeVal() {
      if (this.form.courseLocation != "") {
        getByLocationId({ locationId: this.form.courseLocation }).then(
          (res) => {
            console.log(res);
            if (res.data.data.locationAndCounts != null) {
              this.form.studentMax = res.data.data.locationAndCounts.max;
              this.form.studentMin = res.data.data.locationAndCounts.min;
            } else {
              this.form.studentMax = "";
              this.form.studentMin = "";
            }
          }
        );
      }
      if (this.form.classType != "" && this.form.courseLocation != "") {
        getCoursepackagesByLocationIdAndClasstypeId({
          locationId: this.form.courseLocation,
          classTypeId: this.form.classType,
        }).then((res) => {
          console.log(res);
          if (res.data.data != null) {
            this.form.coursePackages = res.data.data.split(",");
            console.log(this.form.coursePackages);
          }
        });
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    // handleChange(value) {
    //   console.log(value);
    //   // console.log(this.form.coursePackages);
    // },
    getFormatCoursePackagesForCourse() {
      getFormatCoursePackagesForCourse().then((res) => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    //表单提交
    onSubmit(form) {
      // console.log(this.form.coursePackages);
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          // console.log(this.form);
          const para = Object.assign({}, formData);
          // console.log(para.coursePackages);
          // console.log(para);
          var coursePackageString = "";
          para.coursePackages.forEach((value) => {
            // console.log(value);
            coursePackageString = coursePackageString + value + ",";
            // this.coursePackageList.coursePackageList.forEach((item) => {
            //   if (value === item.text) {
            //     coursePackageString = coursePackageString + item.value + ",";
            //   }
            // });
          });
          // console.log(coursePackageString);
          para.coursePackages = coursePackageString;

          // console.log(para);
          let courseDate = formData.courseDate;
          let beginTime = formData.beginTime;
          let endTime = formData.endTime;
          let courseLocation = this.formatList.format_course_location_list[
            parseInt(formData.courseLocation)
          ];
          let courseType = this.formatList.format_course_type_list[
            parseInt(formData.classType)
          ];
          // edit
          if (this.addCourseDialog.type === "edit") {
            editCourse(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "修改未开课课程操作,课程日期为:" +
                    courseDate +
                    ",课程时间段为:" +
                    beginTime +
                    "-" +
                    endTime +
                    ",课程地点为:" +
                    courseLocation +
                    ",课程类型为:" +
                    courseType,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getCourseList");
              }
            });
          } else {
            // add
            addUnBeginCourse(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "新增未开课课程操作,课程日期为:" +
                    courseDate +
                    ",课程时间段为:" +
                    beginTime +
                    "-" +
                    endTime +
                    ",课程地点为:" +
                    courseLocation +
                    ",课程类型为:" +
                    courseType,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getCourseList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
